import { ArrowLeft } from 'lucide-react'

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="container mx-auto px-4 py-3 sm:py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <img 
                src="/images/sportspot-transparent-bg.png" 
                alt="Sportspot Logo" 
                className="h-8 sm:h-12 w-auto"
              />
            </div>
            <div>
              <a href="/" className="inline-flex items-center text-gray-600 hover:text-gray-900 transition-colors">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Home
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">About Sportspot</h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Our Mission</h2>
              <p className="text-gray-700 mb-6">
                Sportspot transforms everyday moments into thrilling competitions by gamifying the simple act of spotting team merchandise in the wild. We believe that sports fandom extends far beyond the stadium, and our platform celebrates the passion that fans carry with them everywhere they go.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">What We Do</h2>
              <p className="text-gray-700 mb-6">
                Our platform allows users to track and collect sightings of team apparel, accessories, and merchandise from major sports leagues including MLB, NBA, NFL, NHL, MLS, and international soccer. Whether you're on a road trip, walking through your neighborhood, or traveling the world, Sportspot turns every outing into an adventure.
              </p>
              
              <div className="grid md:grid-cols-2 gap-8 my-8">
                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">Track Your Collection</h3>
                  <p className="text-gray-700">Build your lifetime collection of spotted teams. Each sighting becomes part of your permanent record, creating a unique map of your sports encounters.</p>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">Compete with Friends</h3>
                  <p className="text-gray-700">Create trip competitions and challenges with friends to see who can spot the most teams during vacations, road trips, or local adventures.</p>
                </div>
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Our Story</h2>
              <p className="text-gray-700 mb-6">
                Sportspot was born from the simple observation that sports fans are everywhere, proudly displaying their team loyalty through jerseys, hats, stickers, and countless other forms of merchandise. We realized that this everyday phenomenon could become the foundation for a fun, social, and competitive experience.
              </p>
              <p className="text-gray-700 mb-6">
                What started as a casual game between friends during road trips has evolved into a comprehensive platform that celebrates sports culture and the passionate communities that surround every team.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Growing Community</h2>
              <p className="text-gray-700 mb-6">
                Our community spans across all major sports leagues and continues to grow as we add new leagues, teams, and features. From die-hard fans to casual observers, Sportspot welcomes anyone who appreciates the ubiquity and passion of sports culture.
              </p>
              <p className="text-gray-700">
                Join thousands of spotters who are turning their daily experiences into exciting competitions and building collections that tell the story of their adventures.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Get Started</h2>
              <p className="text-gray-700 mb-6">
                Ready to start your spotting adventure? Sign up today and begin building your collection. Whether you're planning your next trip or just want to gamify your daily routine, Sportspot is here to make every outing more exciting.
              </p>
              <div className="text-center">
                <a 
                  href="/sign-up" 
                  className="inline-flex items-center bg-[#42a5f5] text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-[#1976d2] transition-colors"
                >
                  Join Sportspot Today
                </a>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}
